<template>
    <component :is="isComponent" :class="wrapperClass">
        <ul :class="['nav nav-tabs', this.class]" :style="{ display: showTabs ? 'flex' : 'none' }">
            <slot></slot>
        </ul>
    </component>
    <div class="tab-content" v-if="$slots.content">
        <slot name="content"></slot>
    </div>
</template>
<script>
export default {
    name: "NavTab",
    props: {
        class: {
            type: String,
            default: ''
        },
        showTabs: {
            type: Boolean,
            default: true
        },
        hasWrapper: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isComponent() {
            return this.hasWrapper ? 'div' : 'slot';
        },
        wrapperClass() {
            return this.hasWrapper ? 'bg-light' : '';
        }
    }
}
</script>